module.exports = __webpack_public_path__ + "img/category-popular-hover.0552f0c3.png";